import {useContext} from "react";
import {ProjectCreationContext} from "./project-creation-context.ts";

const useProjectCreationContext = () => {
    const context = useContext(ProjectCreationContext);
    if (!context)
        throw new Error("useProjectCreationContext must be used within a ProjectCreationContextProvider");
    return context;
}

export default useProjectCreationContext;
